/* eslint-disable consistent-return */
import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';
import { useRouter } from 'next/router';

import { Form, Button, TextInput } from 'components/common';
import { withTranslation } from 'language/i18n';
import { passwordValidator } from 'utils/formValidators';
import { StatusContext } from 'contexts/statusContext';
import { changePassword } from 'models/user';

const PasswordReset = ({ t, token }) => {
  const router = useRouter();

  const { setErrorState } = useContext(StatusContext);

  const [password, setPassword] = useState('');
  const [rePassword, setRePassword] = useState('');
  const [onResponse, setOnResponse] = useState(false);

  const onFormSubmit = async () => {
    if (!onResponse) {
      try {
        setOnResponse(true);
        const data = await changePassword({ password, token });
        if (data.status === 201) {
          router.push({
            pathname: '/forgot-password/success',
          });
        }
      } catch (error) {
        console.log('passwordResetErr', error);
        if (error.status) {
          setErrorState({
            title: t('alert'),
            text: error.message,
            buttonText: t('close'),
            onClickButton: () => setErrorState({}),
          });
        }
      } finally {
        setOnResponse(false);
      }
    }
  };

  return (
    <div className="col-md-10 col-lg-8 offset-lg-1 mt-5 mt-md-0">
      <Form layout="vertical" onFinish={onFormSubmit}>
        <div className="fs-22 fw-900 mb-3">{t('setYourNewPassword')}</div>
        <div className="mb-5">Son şifrenizden farklı bir şifre giriniz.</div>
        <div className="row">
          <div className="col-15 mb-4">
            <TextInput
              type="password"
              name="password"
              value={password}
              placeholder="Yeni Şifreniz"
              onChange={({ value }) => setPassword(value)}
              validator={(rule, value) => {
                if (value === rePassword) {
                  return passwordValidator(rule, value);
                }
                if (rePassword !== '') {
                  return Promise.reject(t('passwordsDoNotMatch'));
                }
              }}
              required
            />
          </div>

          <div className="col-15">
            <TextInput
              type="password"
              name="rePassword"
              value={rePassword}
              placeholder="Yeni Şifreniz(tekrar)"
              onChange={({ value }) => setRePassword(value)}
              validator={(rule, value) => {
                if (value === password) {
                  return passwordValidator(rule, value);
                }

                return Promise.reject(t('passwordsDoNotMatch'));
              }}
              required
            />
          </div>
        </div>
        <Button
          loading={onResponse}
          htmlType="submit"
          className="im-button im-button--primary im-button--fluid im-button--center mt-5 mb-5"
          label={t('savePassword')}
        />
      </Form>
    </div>
  );
};

PasswordReset.propTypes = {
  t: PropTypes.func,
  token: PropTypes.string,
};

export default withTranslation('common')(PasswordReset);
